import { Directive, inject } from '@angular/core'
import { Configuration, ZendeskInitializerService } from '@features/chat/zendesk-initializer.service'
import { ProjectName } from '@app/env-registry'
import { PROJECT } from '@app/tokens'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

const PROJECT_CONFIGURATION: Record<ProjectName, Configuration> = {
  [ProjectName.FINEA] : {
    color: '#093D4A',
    tag: '---Finea---',
    logo: 'app-logo_standalone.svg'
  },
  [ProjectName.DALIDALI] : {
    color: '#8342F6',
    tag: '---DaliDali---',
    logo: 'app-logo_standalone.svg'
  },
  [ProjectName.MINIBANK] : {
    color: '#4fa70d',
    tag: '---Minibank---',
    logo: 'app-logo_standalone.svg'
  }
}

@Directive({
    selector: 'app-chat, [appChat]',
    standalone: true,
})
export class ChatDirective {

  private readonly config = PROJECT_CONFIGURATION[inject(PROJECT)]

  constructor(zendesk: ZendeskInitializerService) {
    zendesk.initialize(this.config).pipe(takeUntilDestroyed()).subscribe()
  }
}
